import PubSub from "../../utils/PubSub";
import { removeFromFavorites } from "../favorites/removeFromFavorites";
import addToFavorites from "../singleProduct/addToFavorites";

export default function setupProductFavorites() {
  // Only select buttons that haven't been initialized and are actual buttons
  const favoriteButtons = document.querySelectorAll(
    "button.products-page-favorite-toggle:not([data-initialized])"
  );

  // Helper function to update button state
  const updateFavoriteButton = (button, isFavorite) => {
    const text = isFavorite
      ? favoritesVars.texts.removeFromFavorites
      : favoritesVars.texts.addToFavorites;
    button.classList.toggle("is-favorite", isFavorite);
    button.setAttribute("aria-label", text);
    button.querySelector(".products-page-favorite-text").textContent = text;
  };

  // Add this new function after updateFavoriteButton
  const updateAllFavoriteButtonsForProduct = (productId, isFavorite) => {
    const buttons = document.querySelectorAll(
      `.products-page-favorite-toggle[data-product-id="${productId}"]`
    );
    buttons.forEach((button) => updateFavoriteButton(button, isFavorite));
  };

  // Subscribe to global favorites events
  PubSub.subscribe("favorites:itemRemoved", ({ productId }) => {
    updateAllFavoriteButtonsForProduct(productId, false);
  });

  favoriteButtons.forEach((button) => {
    // Mark button as initialized
    button.setAttribute("data-initialized", "true");

    // Each button gets its own click handler
    button.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.disabled) return;

      const productId = this.dataset.productId;
      const isFavorite = this.classList.contains("is-favorite");
      const formData = new FormData();
      formData.append("product_id", productId);

      // Store reference to current button for use in event handlers
      const currentButton = this;

      // Setup one-time event handlers specific to this button/action
      const startHandler = () => (currentButton.disabled = true);
      const endHandler = () => (currentButton.disabled = false);
      const successHandler = () =>
        updateFavoriteButton(currentButton, !isFavorite);

      // Subscribe to events with cleanup
      PubSub.subscribeOnce("fetch:addToFavorites:start", startHandler);
      PubSub.subscribeOnce("fetch:removeFromFavorites:start", startHandler);
      PubSub.subscribeOnce("fetch:addToFavorites:end", endHandler);
      PubSub.subscribeOnce("fetch:removeFromFavorites:end", endHandler);

      if (isFavorite) {
        PubSub.subscribeOnce(
          "fetch:removeFromFavorites:success",
          successHandler
        );
        await removeFromFavorites(formData);
      } else {
        PubSub.subscribeOnce("fetch:addToFavorites:success", successHandler);
        await addToFavorites(formData);
      }
    });
  });
}
